import Diamond from './Diamond.png'
import AvenueCutz from './AvenueCutz.png'
import  NaturalSolutions from './NaturalSolutions.png'
import  Aphrodite from './Aphrodite.png'
import  Yeti from './Yeti.png'
import  Char from './Char.png'
import  Tmptd from './Tmptd.png'
import  Initium from './Initium.png'
import TippyToes from './TippyToes.png'
import  Donato from './Donato.png'

export const SaloonData = [
    {img:  Diamond, 
    name: "Diamond Skin & Laser",
    about: "Book an appointment now and you will get 25% discount for your first treatment. 1. We are offering painless hair removal treatment. 2. Skin rejuvenation. Skin rejuvenation encourages collagen growth to help skin become fuller and more youthful. One of the benefits of skin rejuvenation is the ability to clear years of environmental damage, scarring, and discoloration in just a few sessions.",
    location: "4949 Bathurst Street Suite 205 A North York, ON M2R 1Y1 Canada",
    number: "(416) 823-7547",
    },
    {img: AvenueCutz  , 
    name: "Avenue Cutz",
    about: "Welcome to Avenue Cutz, your ultimate destination for beauty, relaxation, and rejuvenation in Canada. Our dedicated team of professionals is committed to providing exceptional services, ensuring you leave feeling refreshed and pampered.",
    location: "918 Pape Avenue East York, ON M4K 3V2 Canada",
    number: "(437) 227-3942",
    },
    {img: NaturalSolutions , 
    name: " Natural Solutions Salon & Spa",
    about: "Introducing Natural Solutions, your haven for luxury and self-care in Canada. Immerse yourself in our serene atmosphere and let our expert team of professionals elevate your beauty and well-being with our indulgent treatments and personalized services. Discover the perfect balance of relaxation and transformation at Natural Solutions.",
    location: "220 Yonge Street Toronto, ON M5B 2H1 Canada",
    number: "(416) 977-4848",
    },
    {img: Aphrodite , 
    name: "Aphrodite Spa & Nails",
    about: "Aphrodite Nails and Spa is a luxurious and rejuvenating beauty destination that offers a wide range of services to enhance your well-being and beauty. Inspired by the timeless beauty and grace of the Greek goddess Aphrodite, this establishment strives to provide an experience that leaves you feeling pampered, confident, and beautiful.",
    location: "1090 Don Mills Roadd Shops At Don Mills Toronto, ON M3C 3R6 Canada",
    number: "(416) 785-9208",
    },
    {img: Yeti , 
    name: "Yeti Nails & Spa",
    about: "Yeti Nails & Spa is one of the best saloon located in the heart of the city of Toronto, Canada. Based on a unique concept, devised to revolutionize the day spa and esthetic world, Yeti Nails & Spa offers the high class experience at an affordable price. Featured services: Pain Free Laser Hair Removal Skin Tag Removal Nails - Manicures & Pedicures Shellac Waxing Threading Facials Tinting Hot Stone Massage Please follow the website for location map and direction.",
    location: "432 Richmond Street W Unit 6 Toronto, ON M5V 1Y1 Canada",
    number: "(416) 306-9892",
    },
    {img: Char, 
    name: "Char Le Blanc Salon",
    about: "Bridal services, Hair services, Hair Coloring, Hair extensions, Tape in extensions, Hair styling, Hair extensions Styling, Keratin Straightening, Perms, Barber, Manicures, Pedicures, make up services",
    location: "2525 Prince Michael Drive Oakville, ON L6H 0E9 Canada",
    number: "(905) 257-7776",
    },
    {img: Tmptd, 
    name: "Tmptd Nail and Blow Dry Bar",
    about: "Step into an environment that blends beauty with a sense of well-being. Each visit will be an unforgettable experience and will leave you feeling empowered and refreshed. At Tmpt(d), you’re guaranteed an impeccable, lasting manicure and/or a flawless hairstyle that will suit your style, features and taste.",
    location: "220 Bloor St W Toronto, ON M5S 1T8 Canada",
    number: "(647) 274-4563",
    },
    {img: Initium , 
    name: "Initium",
    about: "Inium Nails and Spa is a premier beauty destination that offers a comprehensive range of nail and spa services designed to elevate your self-care routine. From the moment you step through their doors, you'll be greeted by a tranquil and inviting atmosphere that sets the stage for a truly relaxing and rejuvenating experience.",
    location: "8241 Woodbine Avenue Unit 6 & 7 Markham, ON L3R 2P1 Canada",
    number: "(905) 947-8880 ",
    },
    {img: TippyToes , 
    name: "Tippy Toes Nails and Spa",
    about: "Tippy Toes Nails and Spa is a haven of beauty and relaxation, offering a wide range of services to help you look and feel your best. Nestled in a charming location, this boutique salon is dedicated to providing a personalized and pampering experience for every client.",
    location: "1224 Dundas Street W Mississauga, ON L5C Canada",
    number: "(905) 275-6245",
    },
    {img: Donato , 
    name: "Donato Salon + Spa",
    about: "SALON: Hair Cutting and Design Colour Perms Blow Dry & Styling Makeup Updos Extensions Straightening Hair Treatments Weddings SPA: Waxing Treatments Hand & Feet Laser Hair Removal Botox & Fillers Massage Wedding Chemical Peels (G.M. Collin) Microdermabrasion Facial Treatments Oxygen Facials Body Treatments Keratherapy Great Lengths Hair Extensions Japanese Straightening System PRODUCTS: Hair Care Skin Care Nail Care Cosmetics Bath + Body For Men Home + Lifestyle",
    location: "Square One Shopping Centre 100 City Centre Drive Mississauga, ON L5B 2C9 Canada",
    number: "(905) 566-5900",
    }
]